<template>
  <div id="app">
    <v-app id="inspire">
      <v-overlay
        :absolute="absolute"
        :opacity="opacity"
        :value="$store.getters.isLoadingFull"
      >
        <v-btn color="orange lighten-2" @click="overlay = false"
          >wird geladen....please wait</v-btn
        >
      </v-overlay>

      <v-app-bar color="white" app elevation="0">
        <!-- Logo links -->
        <v-toolbar-title>
          <a href="/">
            <img
              class="mt-6"
              style="width: 220px"
              src="https://www.clearment.de/images/clearment_lsk/cl_small.png"/></a
        ></v-toolbar-title>
        <!-- Spacer, um den Rest nach rechts zu schieben -->
        <v-spacer></v-spacer>
        <!-- Login-Button rechts -->
        <v-btn text class="redtext button_caps" v-if="!user"
          ><b @click="showLogin = !showLogin">Kunden Login</b></v-btn
        >
        <v-btn text class="redtext button_caps" v-if="user"
          ><b @click="startLogout()">Logout</b></v-btn
        >
      </v-app-bar>
      <div
        class="pa-4"
        style="position: fixed;
  top: 120px;
  left: 0;z-index:1000; width:160px;"
      >
        <menue-out
          v-if="
            !isMobile() &&
              !user_id &&
              vms.length > 0 &&
              $route.name != 'zertifizierung' &&
              $route.name != 'zertifizierungstart'
          "
          :vms="vms"
        />

        <menue v-if="user_id" />
      </div>
      <div
        class="pa-2"
        style="background-color:#f2f2f2;height:48px;margin-top:70px;border-top:2px solid #E0E0E0;"
      >
        <span
          style="font-size:18px;font-weight:bold;margin-left:10px;"
          class="greytext"
          >Die "Versicherung" für Ihre Versicherung</span
        >
      </div>
      <!-- Zentrierter Inhaltsbereich -->
      <div class="content-center mt-2">
        <transition name="fade">
          <router-view style="min-height:1000px;"></router-view>
        </transition>
      </div>
      <v-footer>
        <div class="content-center mt-2 pa-4">
          <a href="/info/impressum">Impressum</a>
        </div></v-footer
      >
    </v-app>
    <v-dialog v-model="showLogin" width="888">
      <v-card height="100">
        <index-login />
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import AppBar from "./components/base/helper/AppBar";
  import NavDrawer from "./components/base/helper/NavDrawer";
  import Error from "./components/base/helper/Error";
  import Menue from "./components/base/helper/Menue";
  import MenueOut from "./components/base/helper/MenueOut";
  import MenueOutMobile from "./components/base/helper/MenueOutMobile";
  import baseMixin from "./components/mixins/baseMixin";
  import IndexLogin from "./components/base/helper/IndexLogin.vue";

  export default {
    name: "index-home",
    mixins: [baseMixin],
    components: {
      IndexLogin,
      AppBar,
      NavDrawer,
      Error,
      Menue,
      MenueOut,
      MenueOutMobile,
    },
    data() {
      return {
        showLogin: false,
        user_id: false,
        showMenue: false,
        absolute: true,
        opacity: 1,
        overlay: false,
        myclient: false,
        allclients: false,
        myhistory: false,
        dialog: false,
        user: false,
        tarif: false,
        hinweise: false,
        drawer: null,
        vms: false,
        items: [
          { icon: "contacts", text: "Contacts" },
          { icon: "history", text: "Frequently contacted" },
        ],
      };
    },
    created() {
      if (!this.isMobile()) {
        this.showMenue = true;
      }
      this.checkLogin();
      this.$log.debug(
        "$store.getters.isLoadingFull",
        this.$store.getters.isLoadingFull
      );
    },
    watch: {
      watchuser: function() {
        if (this.$store.getters.getUserStore.user_id) {
          this.user_id = this.$store.getters.getUserStore.user_id;
        }
      },
    },
    computed: {
      watchuser() {
        if (this.$store.getters.getUserStore) {
          return this.$store.getters.getUserStore;
        } else {
          return false;
        }
      },
    },
    methods: {
      startLogout() {
        // this.$store.commit("user", false);
        //this.$router.push("/logout");
        this.$store.dispatch("startLogout").then((resp) => {
          if (resp.data.success) {
            this.$log.debug("logout");
            //this.$store.commit("user", false);
            window.location.href = "https://www.clearment.de/logout";
          }

          //
        });
      },
      getHomeVms() {
        this.$store
          .dispatch("getHomeVms")
          .then((resp) => {
            if (resp.data) {
              this.vms = resp.data.vms;
            }
          })
          .catch((err) => {
            this.$log.error(err);
          });
      },
      checkLogin() {
        this.$store.dispatch("checkLogin").then((resp) => {
          this.$log.debug("checklogion", resp);
          if (resp.data.user) {
            this.$store.commit("user", resp.data.user);
            this.user = resp.data.user;
            this.tarif = resp.data.tarif;
          } else {
            this.getHomeVms();
          }
        });
      },

      getClient() {
        this.$store.dispatch("getAllClients").then((resp) => {
          if (resp.data) {
            this.$log.debug("ALLClients", resp.data);
            this.myclient = resp.data.myclient;
            this.allclients = resp.data.clients;
            this.myhistory = resp.data.myhistory;
            this.makeFrontLogin(this.myclient.ma_pass);
          }
        });
      },
    },
  };
</script>

<style>
  .content-center {
    max-width: 1000px;
    margin: 0 auto;
    width: 100%;
  }
  .stickyheader {
    border-top: 2px solid black;
    border-bottom: 2px solid black;
    padding: 10px 20px;
    position: fixed; /* Wichtig für Sticky Header */
    top: 0;
    width: 1000px;
    z-index: 1000;
  }
  .app-bar-container {
    display: flex;
    justify-content: center;
    width: 100%;
  }
  .v-app-bar {
    max-width: 1000px;
  }
  .outer-container {
    max-width: 1400px;
    margin: auto;
  }
  .redtext {
    color: #e54c39 !important;
  }
  .greytext {
    color: #6a6a6a !important;
  }

  .redground {
    background-color: #e54c39 !important;
  }
  .greyground {
    background-color: #f2f2f2 !important;
  }

  .button_caps {
    text-transform: none !important;
  }
  .smallcaps {
    text-transform: none !important;
    letter-spacing: normal !important;
    font-size: 20px;
  }
  .smalltext {
    font-size: 12px;
  }
  .textnormal {
    font-size: 14px;
  }
  a:link {
    text-decoration: none;
  }
  h3 {
    font-size: 18px;
  }
</style>
